import { WarningAmberRounded } from "@mui/icons-material";
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    Typography,
} from "@mui/material";
import React from "react";
import { black, greyEnabled, purple, purpleLight, red, redLight } from "../../../../theme/colors";

export default function RevokeAccess({ deleteAdminApiCall, open, setDeleteAdmin, submitting = false }:
    { deleteAdminApiCall: () => void; open: boolean; setDeleteAdmin: (val: boolean) => void; submitting?: boolean }) {
    return (
        <Dialog open={open} onClose={() => !submitting && setDeleteAdmin(false)} PaperProps={{ sx: { borderRadius: 4 } }}>
            <DialogContent sx={{ width: 400, maxWidth: "90vw", p: 4, display: "flex", flexDirection: "column", alignItems: "center" }}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 56,
                        height: 56,
                        borderRadius: "50%",
                        bgcolor: redLight,
                        mb: 2,
                    }}
                >
                    <WarningAmberRounded sx={{ color: red, fontSize: 28 }} />
                </Box>
                <Typography variant="h6" fontWeight={700} color={black} textAlign="center">
                    Revoke this client's access?
                </Typography>
                <Typography variant="body2" color={greyEnabled} textAlign="center" mt={0.5}>
                    This will remove their admin access. This action cannot be undone.
                </Typography>

                <Box display="flex" gap={1.5} width="100%" mt={4}>
                    <Button
                        fullWidth
                        disabled={submitting}
                        onClick={() => setDeleteAdmin(false)}
                        variant="outlined"
                        sx={{
                            borderColor: purple,
                            color: purple,
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: 600,
                            "&:hover": { borderColor: purple, bgcolor: purpleLight },
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        fullWidth
                        disabled={submitting}
                        onClick={() => deleteAdminApiCall?.()}
                        variant="contained"
                        disableElevation
                        startIcon={submitting ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : undefined}
                        sx={{
                            bgcolor: purple,
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: 600,
                            "&:hover": { bgcolor: "#7A2074" },
                        }}
                    >
                        Revoke Access
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
}
